import { render, staticRenderFns } from "./FostersSupport.vue?vue&type=template&id=2bb5f1ba&scoped=true"
import script from "./FostersSupport.vue?vue&type=script&lang=js"
export * from "./FostersSupport.vue?vue&type=script&lang=js"
import style0 from "./FostersSupport.vue?vue&type=style&index=0&id=2bb5f1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5f1ba",
  null
  
)

export default component.exports